export default "__VITE_ASSET__BRltGsgo__"